import jsPDF from 'jspdf';

/**
 * Converts the html pixel sizing to valid jsPDF point measurements.
 * @param {number} html_size Html Pixel Size Value
 * @returns {number} Equivalent points value for given html size
 */
export const convert_html_sizing_to_points = (html_size: number) => (html_size * 72) / 96;

/**
 * Creates Background of specificed colour for any page.
 * @param {jsPDF} pdf_document Current PDF document object being created.
 * @param {string} color HEX code for background color.
 * @param {number} page_width Width of pdf document page.
 * @param {number} page_height Height of pdf document page.
 * @param {number} border_offset Offset from edges of page.
 * @returns {void}
 */
export const generatePageBackground = (
  pdf_document: jsPDF,
  color: string,
  page_width: number,
  page_height: number,
  border_offset: number
): void => {
  pdf_document.setFillColor(color);
  pdf_document.rect(10, 10, page_width - border_offset, page_height - border_offset, 'F');
};

/**
 * Creates Underline for the page heading.
 * @param {jsPDF} pdf_document Current PDF document object being created.
 * @param {string} color Color for line.
 * @param {string} start_y_coordinate Y Coordinate for start of underline.
 * @param {number} page_width Width of pdf document page.
 * @param {number} border_offset Offset from edges of page.
 * @returns {void}
 */
export const generateHeadingUnderline = (
  pdf_document: jsPDF,
  color: string,
  start_y_coordinate: number,
  page_width: number,
  border_offset: number
): void => {
  pdf_document.setDrawColor(color);
  pdf_document.line(
    border_offset * 2,
    start_y_coordinate + border_offset,
    page_width - border_offset * 2,
    start_y_coordinate + border_offset
  );
  pdf_document.setDrawColor('#000000');
};
